// Where a visitor comes from: the feature landing page (?page=borne ...)
// and the campaign tags of the link (utm_*, gclid from Google Ads).
// Captured on first landing (first touch: kept 30 days, never replaced by a
// later visit), in localStorage so it survives the Keycloak signup round
// trip and a signup days later - the same way utils/referral.js keeps an
// ambassador's ?ref. Sent with a demo request (landing/BookDemoDialog.jsx)
// and a facility creation (FacilityForm_v2.jsx); the backend keeps it on
// the commercial lead (backend/utils/attribution.ts).
const STORAGE_KEY = 'qrproof:attribution';
const SESSION_VISIT_KEY = 'qrproof:landingVisit';
const MAX_AGE_MS = 30 * 24 * 3600 * 1000;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://192.168.1.17:8080';

export const LANDING_PAGES = ['borne', 'avis-verifies', 'conciergerie', 'statistiques', 'evenements'];
const KEYS = ['page', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

function readStored() {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!raw || Date.now() - Number(raw.at) > MAX_AGE_MS) return null;
    return raw;
  } catch {
    return null;
  }
}

export function captureAttribution(search = window.location.search) {
  const params = new URLSearchParams(search);
  const found = {};
  for (const k of KEYS) {
    const v = (params.get(k) || '').trim();
    if (v) found[k] = v.slice(0, 255);
  }
  if (found.page && !LANDING_PAGES.includes(found.page)) delete found.page;
  if (!Object.keys(found).length || readStored()) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...found, at: Date.now() }));
  } catch {
    // Storage unavailable (private browsing): the origin just isn't kept.
  }
}

/** { page, utm_*, gclid } or null. */
export function getAttribution() {
  const stored = readStored();
  if (!stored) return null;
  const { at, ...attribution } = stored;
  return attribution;
}

/** Anonymous count of a landing page visit, once per browser session.
 *  `params`: the URLSearchParams of the page (its utm_* tags). */
export function recordLandingVisit(page, params = new URLSearchParams(window.location.search)) {
  try {
    if (sessionStorage.getItem(SESSION_VISIT_KEY) === page) return;
    sessionStorage.setItem(SESSION_VISIT_KEY, page);
  } catch {
    // no sessionStorage: count it anyway
  }
  const body = { page };
  for (const k of KEYS.slice(1)) if (params.get(k)) body[k] = params.get(k);
  fetch(`${API_BASE_URL}/public/landing-visit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}
